var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-grouped-drop-down',{attrs:{"items":_vm.items,"selection":_vm.selected,"noneLabel":"- none -","noLabel":"","valueAttribute":"itemId"},on:{"update:selection":function($event){_vm.selected=$event}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77d90aac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservation/details/travelers/Coupe.vue
// module id = null
// module chunks = 